export const EFDBKey = {
  country: 'country',
  facilityName: 'name',
  facilityId: 'facilityId',
  year: 'year',
  scope1: 'scope1',
  scope2: 'scope2',
  scope3: 'scope3'
};

export const EFDBLabel = {
  country: 'Country',
  facilityName: 'Facility Name',
  year: 'Year',
  scope1: 'Scope 1',
  scope2: 'Scope 2',
  scope3: 'Scope 3'
};
